import { JobCredentials } from './job-credentials';

export interface Job {
    id?: string;
    description: string;
    createdOn?: string;
    createdBy?: string;
    completed?: boolean;
    hasErrors?: boolean;
    credentials?: JobCredentials;
}
